import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGrouponComponent } from './simple-icons-groupon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGrouponComponent ],
    exports:      [ SimpleIconsGrouponComponent ],
    bootstrap:    []
})
export class SimpleIconsGrouponModule {}
